import thunkMiddleware from "redux-thunk";
import { combineReducers, createStore, applyMiddleware } from "redux";
import reducers from "./reducers";

const reducer = combineReducers(reducers);
const createStoreWithMiddleware = applyMiddleware(thunkMiddleware)(createStore);

export default createStoreWithMiddleware(reducer);



// WEBPACK FOOTER //
// ./src/reducers/index.js